/* Homepage badges follow the reading-time label published inside each post.
   Fetch only when the section approaches the viewport; keep the Liquid value
   if a post cannot be reached. EComposer's specific 'Reading time' label takes
   priority over the generic 'Read time' in its duplicate mobile template. */
(function () {
  'use strict';
  if (window.mrHomeArticleTimesReady) return;
  window.mrHomeArticleTimesReady = true;
  var requests = new Map();

  function readMinutes(doc) {
    var nodes = Array.from(doc.querySelectorAll('main .ecom-iconlist--des'));
    if (!nodes.length) nodes = Array.from(doc.querySelectorAll('.ecom-iconlist--des'));
    var patterns = [/^reading\s+time\s*:?\s*(\d+)\s*min(?:ute)?s?\b/i, /^read\s+time\s*:?\s*(\d+)\s*min(?:ute)?s?\b/i];
    for (var pattern of patterns) {
      for (var node of nodes) {
        var text = Array.from(node.children).map(function (child) { return child.textContent; }).join(' ');
        var match = (text || node.textContent || '').replace(/\s+/g, ' ').trim().match(pattern);
        if (match && Number(match[1]) > 0) return Number(match[1]);
      }
    }
    return null;
  }

  function loadMinutes(url) {
    if (!requests.has(url)) {
      requests.set(url, (async function () {
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 10000);
        try {
          var response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) return null;
          var html = await response.text();
          // Detached parsing: no post scripts are executed or inserted.
          return readMinutes(new DOMParser().parseFromString(html, 'text/html'));
        } catch (_) {
          return null;
        } finally {
          clearTimeout(timeout);
        }
      })());
    }
    return requests.get(url);
  }

  async function updateSection(section) {
    var links = Array.from(section.querySelectorAll('.mr-cards__card--article .mr-cards__link'));
    async function worker() {
      while (links.length) {
        var link = links.shift();
        var url;
        try { url = new URL(link.getAttribute('href'), location.href); } catch (_) { continue; }
        if (url.origin !== location.origin || !/\/blogs\/[^/]+\/[^/]+/.test(url.pathname)) continue;
        var minutes = await loadMinutes(url.href);
        if (!minutes || !link.isConnected) continue;
        var badge = link.querySelector('.mr-cards__badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'mr-cards__badge';
          link.appendChild(badge);
        }
        badge.textContent = minutes + ' min read';
      }
    }
    await Promise.all([worker(), worker()]);
  }

  function init() {
    document.querySelectorAll('[data-mr-article-times]').forEach(function (section) {
      if (section.dataset.mrTimesBound) return;
      section.dataset.mrTimesBound = 'true';
      if (!('IntersectionObserver' in window)) { updateSection(section); return; }
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          updateSection(section);
        }
      }, { rootMargin: '800px 0px' });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
